import React, {useEffect, useContext, useState} from 'react'
import {Button, Card, Col, Row} from "antd";
import PurchaseInfos from "./PurchaseInfos";
import PurchaseList from "./PurchaseList";
import {getAllStock} from "../../../services/serviceStock";
import {PurchaseContext} from "../../../context/PurchaseContext";
import {createPurchase} from "../../../services/servicePurchase";
import {enterLoadingState, exitLoadingState} from "../../../utils/helpers/commonFunctions";


const PurchaseCreate = () => {
    const {stocks, purchaseItems, purchaseInfos} = useContext(PurchaseContext)
    const [, setStockList] = stocks
    const [purchaseList] = purchaseItems
    const [purchaseInformations] = purchaseInfos
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getAllStock()
            .then(({data}) => reduceStockData(data))
    }, [])

    const reduceStockData = (data) => {
        const contextList = data.map(item => {
            return {
                text: `${item.code || ''} - ${item.name || ''}`,
                value: item.id,
                code: item.code || '',
                currency: item.currency || '',
                description: item.description || '',
                id: item.id || '',
                name: item.name || '',
                price: item.price || '',
                quantity: item.quantity || '',
                recipe: item.recipe || null,
                unit: item.unit || ''
            }
        })
        setStockList(contextList)
    }
    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        const contentOfPurchaseList = purchaseList.map(item => {
            return {
                shippingDate: item.shippingDate,
                stock: {
                    id: item.stock,
                },
                quantity: item.quantity,
                unit: item.unit
            }
        })

        const requestObj = {
            contentOfPurchaseList: contentOfPurchaseList || [],
            delivery: purchaseInformations.delivery || '',
            payment: purchaseInformations.payment || '',
            whom: purchaseInformations.whom || '',
            exchangeRate: purchaseInformations.exchangeRate || ''
        }

        createPurchase(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setTimeout(() => window.history.back(), 500)
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Card title={'Satın Alma Oluştur'}
                  extra={<Button onClick={handleSubmit} loading={loadings[0]} type={'primary'}> Oluştur </Button>}
            >
                <PurchaseInfos/>
                <Row justify={'start'}>
                    <Col span={12}>
                        <h4>Satın Alma Listesi</h4>
                    </Col>
                </Row>
                <PurchaseList/>
            </Card>
        </React.Fragment>
    )
}

export default PurchaseCreate